import React, { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { ImportantButton } from 'components';
import { HelpCardsSection, HelpWordTableSection, HelpAddWordSection} from './components'
import './HelpPage.css';

const HelpPage = () => {
  const auth = useAuth();
  const isLoggedIn = auth.isAuthenticated;
  const [step, setStep] = useState('cards');

  if (step === 'cards') {
    return <HelpCardsSection onFinish={() => setStep('menu')} />;
  }

  if (step === 'wordTable') {
    return <HelpWordTableSection onBack={() => setStep('menu')} />;
  }

  if (step === 'addWord') {
    return <HelpAddWordSection onBack={() => setStep('menu')} onNavigate={setStep} />;
  }

  return (
    <div className="help-page">
      <div className="help-finished">
        {isLoggedIn ? (
          <p>Head to the home page to go through your own cards.</p>
        ) : (
          <>
            <p>
              Once you create an account you can add your own words and AutoLexi will cycle through them so
              you can become familiar with their definitions at your own pace.
            </p>
            <p>AutoLexi will encourage you to revise words you are not yet confident with.</p>
          </>
        )}
        <ImportantButton buttonText="Try again" onClick={() => setStep('cards')} />
        <div className="help-section-menu">
          <p className="help-section-menu-title">Explore other sections</p>
          <div className="help-section-menu-buttons">
            <ImportantButton buttonText="Word Table" onClick={() => setStep('wordTable')} />
            <ImportantButton buttonText="Add Word" onClick={() => setStep('addWord')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export { HelpPage };
